<template>
  <apexchart type="donut" :height="height" :options="mergedOptions" :series="series" />
</template>

<script>
import { baseChartOptions, mergeOptions } from "./palette";

export default {
  name: "DonutChart",
  props: {
    // [30, 50, 20]
    series: { type: Array, required: true },
    labels: { type: Array, default: () => [] },
    height: { type: [Number, String], default: 320 },
    id: { type: String, default: "donut-chart" },
    showTotal: { type: Boolean, default: true },
    totalLabel: { type: String, default: "Total" },
    options: { type: Object, default: () => ({}) },
  },
  computed: {
    mergedOptions() {
      const base = baseChartOptions(this.id);
      base.labels = this.labels;
      base.plotOptions = {
        pie: {
          donut: {
            size: "65%",
            labels: {
              show: true,
              total: { show: this.showTotal, label: this.totalLabel },
            },
          },
        },
      };
      return mergeOptions(base, this.options);
    },
  },
};
</script>
